/**
 * AgenticRx flags from getUserServiceLevels.do.
 *
 * The backend fields are not live yet. Until they are present on the payload, we
 * keep using the real API response and overlay these static defaults. Flip them
 * to preview; remove the TEMP_* constants once the API returns the flags.
 *
 * - `isAgentixRxEnabled` — clinic can use AgenticRx
 * - `isAgentixRxDefault` — AgenticRx is the default Rx experience (ignored unless enabled)
 */
export const TEMP_IS_AGENTIX_RX_ENABLED = true;
export const TEMP_IS_AGENTIX_RX_DEFAULT = true;

function parseFlag(raw: unknown): boolean | undefined {
  if (typeof raw === "boolean") return raw;
  if (typeof raw === "number") return raw === 1;
  if (typeof raw === "string") {
    const value = raw.trim().toLowerCase();
    if (["true", "y", "yes", "1"].includes(value)) return true;
    if (["false", "n", "no", "0"].includes(value)) return false;
  }
  return undefined;
}

function readFlag(servicesData: any, key: string, fallback: boolean): boolean {
  try {
    if (servicesData == null || typeof servicesData !== "object") {
      return fallback;
    }
    const parsed = parseFlag(servicesData[key]);
    if (parsed !== undefined) return parsed;
  } catch {
    /* fall through to static default */
  }
  return fallback;
}

export function resolveIsAgentixRxEnabled(servicesData: any): boolean {
  return readFlag(servicesData, "isAgentixRxEnabled", TEMP_IS_AGENTIX_RX_ENABLED);
}

/** True when AgenticRx should be the default pad. Always false if AgenticRx is off. */
export function resolveIsAgentixRxDefault(servicesData: any): boolean {
  if (!resolveIsAgentixRxEnabled(servicesData)) return false;
  return readFlag(servicesData, "isAgentixRxDefault", TEMP_IS_AGENTIX_RX_DEFAULT);
}
